import { useCopilotAction } from '@copilotkit/react-core';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { TOOL_NAMES } from '@/helpers/aiChat/tools';

const SUPPORTED_HR_SYSTEMS = [
  'ADP Workforce Now',
  'ADP Run',
  'ADP Workforce Now Next Generation',
  'Justworks',
  'Paychex',
  'UKG Ready',
  'TriNet',
  'BambooHR',
  'Gusto',
  'Paylocity',
  'Google Workspace',
  'Microsoft Entra',
];

export const useConnectHrSystemTool = () => {
  const navigate = useNavigate();

  useCopilotAction({
    name: TOOL_NAMES.CONNECT_HR_SYSTEM,
    description:
      'Navigates to the Integrations page and provides step-by-step guidance for connecting an HR system. Use this when the admin wants to connect their HR system to Electric. Only use this tool for supported HR systems.',
    parameters: [
      {
        name: 'hr_system_name',
        type: 'string',
        description: `The name of the HR system to connect. Must be one of the supported systems: ${SUPPORTED_HR_SYSTEMS.join(', ')}. Ask the admin if not known. Do not suggest or accept HR systems not on this list.`,
        required: false,
      },
    ],
    handler: async ({ hr_system_name }) => {
      if (!hr_system_name) {
        return `Which HR system would you like to connect to Electric? Supported systems: ${SUPPORTED_HR_SYSTEMS.join(', ')}.`;
      }

      const isSupported = SUPPORTED_HR_SYSTEMS.some(
        s => s.toLowerCase() === hr_system_name.toLowerCase()
      );

      if (!isSupported) {
        return `Sorry, **${hr_system_name}** is not a supported HR system integration. Electric currently supports: ${SUPPORTED_HR_SYSTEMS.join(', ')}.`;
      }

      navigate(ROUTES.SETTINGS_INTEGRATIONS);

      return (
        `Navigated to the Integrations page. ` +
        `To start, find **${hr_system_name}** in the HR Systems section and click the **three dots (⋯)** menu on its card. ` +
        `Use your knowledge base to guide the admin through the rest of the connection flow for ${hr_system_name}.`
      );
    },
  });
};
